import { AccessGate } from './components/AccessGate';
import { ChatWidget } from './components/ChatWidget';

export default function App() {
  return (
    <AccessGate>
      <ChatWidget />
    </AccessGate>
  );
}
